import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import ProfilePicture from "../UserProfile/ProfilePicture";
import { IoIosCloseCircle } from "react-icons/io";
import { deleteDoc, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../FirebaseConfig";
import { toastOptions } from "../lib/toastOptions";
import { toast } from "react-toastify";
import useChatClient from "../StatesStore/ChatClient";
import { Link } from "react-router-dom";
import { UserAuth } from "../Context";
import useModalStore from "../StatesStore/ModalStore";

const UserDetailsModal = ({
  show,
  members,
  listId,
  listName,
  userId,
  rolesOptions,
  setShowModal,
  setMemberDetails,
  loading,
}) => {
  // console.log("members", members);
  const [filterMembers, setFilterMembers] = useState(members);
  const { user } = UserAuth();
  const [searchTerm, setSearchTerm] = useState("");
  const [DATA, setDATA] = useState({
    friendId: "",
    displayName: "",
  });
  const client = useChatClient((state) => state.client);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const { openModal } = useModalStore();
  const onClose = () => {
    setSearchTerm("");
    setShowModal(false);
  };
  useEffect(() => {
    if (searchTerm.trim() === "") {
      setFilterMembers(members);
    }
    const filtered = members.filter(
      (member) =>
        member.userName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        member.userTitle?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilterMembers(filtered);
  }, [searchTerm, members]);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!client) {
    return null;
  }

  const handleRoleChange = async (memberId, newRole) => {
    try {
      // Reference to the members subcollection
      const memberRef = doc(
        db,
        "users",
        userId,
        "shoppingList",
        listName,
        "members",
        memberId
      );

      // Reference to the invitedList document
      const invitedListRef = doc(db, "users", memberId, "invitedList", listId);

      // Perform updates in Firestore
      await Promise.all([
        updateDoc(memberRef, { role: newRole }),
        updateDoc(invitedListRef, { role: newRole }),
      ]);

      // Update role in frontend state
      setMemberDetails((prevDetails) =>
        prevDetails.map((member) =>
          member.id === memberId ? { ...member, role: newRole } : member
        )
      );

      toast.success("Role updated successfully", toastOptions);
    } catch (error) {
      console.error("Error updating role:", error);
      toast.error("Failed to update role. Please try again.", toastOptions);
    }
  };

  const handleRevokeUser = async (index, Id) => {
    console.log("handleRevokeUser", Id);
    const docRef = doc(
      db,
      "users",
      userId,
      "shoppingList",
      listName,
      "members",
      Id
    );
    const invitedListRef = doc(db, "users", Id, "invitedList", listId);
    const docSnap = await getDoc(docRef);
    const channel = client.channel("team", listId);
    await channel.removeMembers([Id]);
    setShowModal(false);
    try {
      if (docSnap.exists) {
        // Remove the friend from the array
        await deleteDoc(docRef);
        await deleteDoc(invitedListRef);
        const newData = members?.filter((memeber) => memeber.id !== Id);
        setMemberDetails(newData);
        console.log("friendsData", newData);
        toast.success("User removed successfully!", toastOptions);
      }
      // await updateDoc(chatRef,{members:[...updatedMembers]})
    } catch (error) {
      console.error(error);
      toast.error("Error removing user!", toastOptions);
    }
  };
  const handleClickUnfollow = (friendData) => {
    const modalData = {
      userData: friendData,
      modalHeaderText: "Confirm Remove?",
      modalBodyText: () => {
        return (
          <div
            style={{
              fontFamily: "Inter",
              fontWeight: "400",
              fontSize: "16px",
              letterSpacing: "0%",
              lineHeight: isSmallScreen ? "116%" : "146%",
              textAlign: isSmallScreen ? "center" : "left",
              verticalAlign: isSmallScreen ? "middle" : "",
              color: "#676A79",
            }}
          >
            Are you sure you want to remove{" "}
            <span
              style={{
                fontWeight: "500",
                color: "#000000",
              }}
            >
              {friendData?.userName}
            </span>
            ? This action cannot be undone.
          </div>
        );
      },
      handleConfirm: () => {
        handleRevokeUser("", friendData.id);
      },
      confirmButtonText: "Remove",
    };
    openModal("RemoveFollowerFollowingModal", "user", modalData);
  };
  return (
    <>
      <Modal show={show} centered onHide={onClose} className="renameModal">
        <style jsx>
          {`
            .renameModal .modal-content {
              box-shadow: 0 0.5rem 1rem rgba(83, 88, 93, 0.25) !important;
              border-radius: 20px !important;
              max-height: 576px;
            }

            .renameModal .modal-dialog {
              max-width: 570px;
              margin: 1rem auto; /* Add some margin */
            }
            .search-bar {
              position: relative;
            }

            .search-input {
              height: 46px;
              border-radius: 12px;
              border-width: 0.86px;
              padding: 6px;
              padding-left: 2rem;
              border: 0.86px solid #c3c3c3;
              font-size: 14px;
              width: 100%;
            }

            .renameModalbuttonStyle {
              height: 56px;
              border-radius: 12px;
              padding: 0px 16px;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .buttonTextStyle {
              font-family: Inter;
              font-weight: 400;
              font-size: 18px;
              line-height: 100%;
              letter-spacing: 2%;
              text-align: center;
            }
          `}
        </style>

        <Modal.Body style={{ padding: isSmallScreen ? "20px" : "40px " }}>
          <div
            className="d-flex flex-column"
            style={{ gap: isSmallScreen ? "20px" : "32px" }}
          >
            <div className="d-flex w-100 justify-content-between">
              <div
                style={{
                  fontFamily: "Inter",
                  color: "#101828",
                  fontWeight: "600",
                  fontSize: "24px",
                  lineHeight: "24px",
                  letterSpacing: "0%",
                }}
              >
                Manage members
              </div>
              <button
                type="button"
                style={{
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "27px",
                  height: "27px",
                  background: "#FFFFFF",
                  border: "1px solid #FF3B30",
                  boxShadow: "1px 1px 5px rgba(30, 30, 30, 0.14)",
                  borderRadius: "25px",
                  flex: "none",
                  order: "1",
                  flexGrow: "0",
                }}
                onClick={onClose}
              >
                <svg
                  style={{ width: "11px" }}
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13 1L1 13M1 1L13 13"
                    stroke="#FF3B30"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
            <div className="d-flex flex-column" style={{ gap: "24px" }}>
              {/* <div className="search-bar">
                <svg
                  style={{
                    position: "absolute",
                    top: "12px",
                    left: "8px",
                    height: "24px",
                  }}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.5077 8.40593C11.1961 8.43895 10.9702 8.71838 11.0032 9.03006C11.0363 9.34174 11.3157 9.56763 11.6274 9.53461L11.5077 8.40593ZM12.9086 10.2894C13.0308 10.5781 13.3638 10.713 13.6525 10.5908C13.9411 10.4686 14.076 10.1356 13.9538 9.84695L12.9086 10.2894ZM15.2698 14.3715C15.048 14.1501 14.6887 14.1504 14.4673 14.3722C14.2458 14.594 14.2462 14.9533 14.468 15.1747L15.2698 14.3715ZM17.0316 17.7338C17.2534 17.9553 17.6127 17.955 17.8342 17.7331C18.0556 17.5113 18.0553 17.152 17.8334 16.9305L17.0316 17.7338ZM11.6274 9.53461C12.1741 9.47668 12.6943 9.78316 12.9086 10.2894L13.9538 9.84695C13.5447 8.88045 12.5515 8.29533 11.5077 8.40593L11.6274 9.53461ZM14.468 15.1747L17.0316 17.7338L17.8334 16.9305L15.2698 14.3715L14.468 15.1747Z"
                    fill="#676A79"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.46452 14.6801C6.76291 13.9765 6.28703 13.0862 6.09593 12.1195C5.90323 11.1501 6.00218 10.1466 6.38068 9.23146C6.75594 8.32151 7.39661 7.54074 8.22224 6.98718C9.89738 5.86365 12.1026 5.86365 13.7777 6.98718C14.6034 7.54074 15.2441 8.32151 15.6193 9.23146C15.9978 10.1466 16.0968 11.1501 15.904 12.1195C15.713 13.0862 15.2371 13.9765 14.5354 14.6801C13.6063 15.6164 12.3314 16.1445 11 16.1445C9.66861 16.1445 8.3937 15.6164 7.46452 14.6801Z"
                    stroke="#676A79"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <input
                  type="text"
                  id="searchInput"
                  className="search-input"
                  placeholder="Search members"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div> */}
              {members?.length > 0 ? (
                <>
                  <div
                    className="d-flex flex-column"
                    style={{ gap: isSmallScreen ? "12px" : "16px" }}
                  >
                    {filterMembers.map((member, index) => (
                      <div
                        key={member.id}
                        className="d-flex justify-content-between align-items-center w-100 my-1"
                      >
                        <Link
                          to={`/userProfile/${member?.id}`}
                          className="d-flex align-items-center"
                          style={{ gap: "12px" }}
                        >
                          <img
                            src={
                              member?.photo ||
                              `https://ui-avatars.com/api/?name=${member?.userName[0]?.toUpperCase()}`
                            }
                            loading="lazy"
                            width={"50px"}
                            height={"50px"}
                            style={{
                              borderRadius: "12px",
                              width: "50px",
                              height: "50px",
                              objectFit: "cover",
                              objectPosition: "top",
                            }}
                            alt=""
                          />
                          <div className="d-flex align-items-center gap-1">
                            <div
                              style={{
                                fontFamily: "Inter",
                                fontWeight: 600,
                                fontSize: "18px",
                                lineHeight: "100%",
                                letterSpacing: "0%",
                                color: "black",
                              }}
                            >
                              {member.userName}
                            </div>
                            {(member.role === "Owner" ||
                              member.id === user?.uid) && (
                              <div
                                style={{
                                  fontFamily: "Inter",
                                  fontWeight: 500,
                                  fontSize: "12px",
                                  lineHeight: "100%",
                                  letterSpacing: "0%",
                                  color: "#676A79",
                                }}
                              >
                                {member.id === user?.uid ? "You" : "Owner"}
                              </div>
                            )}
                          </div>
                        </Link>
                        {userId === user?.uid && member.id !== user?.uid && (
                          <svg
                            style={{
                              cursor: "pointer",
                              backgroundColor: "#C3C3C3",
                              borderRadius: "12px",
                              color: "white",
                            }}
                            onClick={() => {
                              // console.log("data", data);
                              handleClickUnfollow(member);
                            }}
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7 7L17 17"
                              stroke="white"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M7 17L17 7"
                              stroke="white"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        )}
                        {/* <div
                          className="d-flex justify-content-end align-items-center"
                          style={{ gap: "6px" }}
                        >
                          <Form.Select
                            style={{
                              height: "2rem",
                              paddingLeft: "9.5px",
                              border: "1px solid #676A79",
                              cursor: "pointer",
                            }}
                            className="py-1 bg-transparent"
                            onChange={(event) =>
                              handleRoleChange(member.id, event.target.value)
                            }
                            value={member.role || "commentor"}
                          >
                            {rolesOptions.map((option) => (
                              <option key={option.name} value={option.name}>
                                {option.label}
                              </option>
                            ))}
                          </Form.Select>
                          <svg
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setDATA({
                                friendId: member.id,
                                displayName: member?.userName,
                              });
                              // console.log("data", data);
                              setShowRemoveModal(true);
                            }}
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7 7L17 17"
                              stroke="#14191F"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M7 17L17 7"
                              stroke="#14191F"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div> */}
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <p className="text-center text-muted">No members found.</p>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UserDetailsModal;
